<template>
  <div>
    <div class="">
      <nav class="flex space-x-4" aria-label="Tabs">
        <span
          v-for="tab in tabs"
          :key="tab.name"
          :class="[
            tab.id == curTabId
              ? 'bg-indigo-200 text-indigo-700 dark:bg-indigo-900 dark:text-indigo-100'
              : 'text-gray-800 dark:text-gray-200 text-semibold',
            'rounded-md px-3 py-2 text-sm font-bold cursor-pointer hover:bg-indigo-200 dark:hover:bg-indigo-900',
          ]"
          @click.prevent="onTabs(tab.id)"
          >{{ tab.name }}</span
        >
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
const emit = defineEmits<{
  (e: "cur-tab-id", id: number): void;
  (e: "cur-tab-value", value: string): void;
}>();

const props = defineProps<{
  tabs: {
    name: string;
    id: number;
    current: boolean;
  }[];
}>();

const curTabId = ref(0);
const onTabs = (id: number) => {
  curTabId.value = id;
  emit("cur-tab-id", id);
};
</script>
